export default class GoogleMapsHelper {
  public static googleMaps: any = null;
  public static infowindow: any = null;
  public static initZoom: number = 7;
  public static initLat: number = 45.5958307;
  public static initLong: number = 9.8241264;
  public static defaultMarkerIconName = "marker.svg";
  public static isMapTypeControl = false;
  public static isZoomControl = true;
  public static isStreetViewControl = false;
  public static isScrollWheel = false;
  public static isKeyboardShortcuts = true;
  public static isPanControl = false;
  public static isDisableDoubleClickZoom = false;
  public static styles = [{ featureType: "all", elementType: "all", stylers: [{ saturation: -50 }] }];

  static set() {
    const self = this;

    self.setMarkers();
    (<any>window).google.maps.event.addDomListener(window, "load", self.loadMap);
    (<any>window).google.maps.event.addDomListener(window, "resize", self.resizeMap);
  }

  static loadMap() {
    var mapOptions = {
      zoom: GoogleMapsHelper.initZoom,
      center: new (<any>window).google.maps.LatLng(GoogleMapsHelper.initLat, GoogleMapsHelper.initLong),
      mapTypeControlOptions: {
        mapTypeIds: [(<any>window).google.maps.MapTypeId.ROADMAP, "styles"]
      },
      mapTypeControl: GoogleMapsHelper.isMapTypeControl,
      zoomControl: GoogleMapsHelper.isZoomControl,
      streetViewControl: GoogleMapsHelper.isStreetViewControl,
      scrollwheel: GoogleMapsHelper.isScrollWheel,
      disableDoubleClickZoom: GoogleMapsHelper.isDisableDoubleClickZoom,
      keyboardShortcuts: GoogleMapsHelper.isKeyboardShortcuts,
      panControl: GoogleMapsHelper.isPanControl
    };

    GoogleMapsHelper.googleMaps = new (<any>window).google.maps.Map(document.getElementById("GoogleMaps"), mapOptions);
    GoogleMapsHelper.googleMaps.mapTypes.set("styles", new (<any>window).google.maps.StyledMapType(GoogleMapsHelper.styles, { name: "Styles" }));
    GoogleMapsHelper.googleMaps.setMapTypeId("styles");

    $.each($(".googlemaps .marker"), function (i) {
      var marker = $(this).attr("data-marker"),
        width = parseInt($(this).attr("data-width")) / 2,
        height = parseInt($(this).attr("data-height")) / 2,
        lat = $(this).attr("data-lat"),
        long = $(this).attr("data-long"),
        title = $(this).attr("data-title"),
        contents = $(this).html();

      var latlng = new (<any>window).google.maps.LatLng(lat, long);
      GoogleMapsHelper.googleMaps.addMarker(GoogleMapsHelper.newMarker(title, marker, width, height, contents, latlng));
    });
  }

  static resizeMap() {

    var center = GoogleMapsHelper.googleMaps.getCenter();
    (<any>window).google.maps.event.trigger(GoogleMapsHelper.googleMaps, "resize");
    GoogleMapsHelper.googleMaps.setCenter(center);
  }

  static newMarker(name, icon, width, height, contents, latlng) {
    const self = this;

    var image = {
      url: "/images/" + (icon ? icon : self.defaultMarkerIconName),
      size: new (<any>window).google.maps.Size(width, height),
      scaledSize: new (<any>window).google.maps.Size(width, height)
    };

    var marker = new (<any>window).google.maps.Marker({
      title: name,
      position: latlng,
      map: self.googleMaps,
      icon: image,
      optimized: false
    });

    (<any>window).google.maps.event.addListener(marker, "click", function () {
      if (self.infowindow) {
        self.infowindow.close();
      }
      self.infowindow = new (<any>window).google.maps.InfoWindow({ content: contents });
      self.infowindow.open(self.googleMaps, marker);
    });

    (<any>window).google.maps.event.addListener(self.googleMaps, "click", function () {
      if (self.infowindow) {
        self.infowindow.close();
      }
    });

    return marker;
  }

  static setMarkers() {
    const self = this;

    (<any>window).google.maps.Map.prototype.markers = new Array();

    (<any>window).google.maps.Map.prototype.addMarker = function (marker) {
      this.markers[this.markers.length] = marker;
    };

    (<any>window).google.maps.Map.prototype.getMarkers = function () {
      return this.markers;
    };

    (<any>window).google.maps.Map.prototype.clearMarkers = function () {
      if (self.infowindow) {
        self.infowindow.close();
      }

      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].set_map(null);
      }
    };
  }
}